module.exports = "form {\n  margin: 50px auto 0 0;\n}\n\n.full-width {\n    display: block;\n    margin: 0 auto;\n    width: 80%;\n    max-width: 600px;\n}\n\n.app-toolbar-spacer {\n  -webkit-box-flex: 1;\n      -ms-flex: 1 1 auto;\n          flex: 1 1 auto;\n}\n\nmat-toolbar {\n  margin: 0 auto;\n  width: 80%;\n  max-width: 600px;\n}\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/components/testata/testata-form/testata-form.component.css
// module id = ./src/app/components/testata/testata-form/testata-form.component.css
// module chunks = main